import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connectGeoSearch } from 'react-instantsearch-dom';
import { LatLngPropType, BoundingBoxPropType } from "./propTypes.js";

function isEqualPosition(a, b) {
  if (a === b) {
    return true;
  }

  if (a === undefined || b === undefined) {
    return false;
  }

  return a.lat === b.lat && a.lng === b.lng;
}

function isEqualCurrentRefinement(a, b) {
  if (a === b) {
    return true;
  }

  if (a === undefined || b === undefined) {
    return false;
  }

  return isEqualPosition(a.northEast, b.northEast) && isEqualPosition(a.southWest, b.southWest);
}

export var Connector = /*#__PURE__*/function (_Component) {
  _inherits(Connector, _Component);

  var _super = _createSuper(Connector);

  function Connector() {
    var _this;

    _classCallCheck(this, Connector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isRefineOnMapMove: _this.props.enableRefineOnMapMove,
      hasMapMoveSinceLastRefine: false,
      previousPosition: _this.props.position,
      previousCurrentRefinement: _this.props.currentRefinement
    });

    _defineProperty(_assertThisInitialized(_this), "toggleRefineOnMapMove", function () {
      return _this.setState(function (_ref) {
        var isRefineOnMapMove = _ref.isRefineOnMapMove;
        return {
          isRefineOnMapMove: !isRefineOnMapMove
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setMapMoveSinceLastRefine", function (next) {
      var hasMapMoveSinceLastRefine = _this.state.hasMapMoveSinceLastRefine;

      if (hasMapMoveSinceLastRefine === next) {
        return;
      }

      _this.setState(function () {
        return {
          hasMapMoveSinceLastRefine: next
        };
      });
    });

    return _this;
  }

  _createClass(Connector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hits = _this$props.hits,
          isRefinedWithMap = _this$props.isRefinedWithMap,
          position = _this$props.position,
          currentRefinement = _this$props.currentRefinement,
          refine = _this$props.refine,
          children = _this$props.children;
      var _this$state = this.state,
          isRefineOnMapMove = _this$state.isRefineOnMapMove,
          hasMapMoveSinceLastRefine = _this$state.hasMapMoveSinceLastRefine;
      return children({
        toggleRefineOnMapMove: this.toggleRefineOnMapMove,
        setMapMoveSinceLastRefine: this.setMapMoveSinceLastRefine,
        hits: hits,
        isRefinedWithMap: isRefinedWithMap,
        isRefineOnMapMove: isRefineOnMapMove,
        // @MAJOR hasMapMoveSinceLastRefine -> hasMapMovedSinceLastRefine
        hasMapMoveSinceLastRefine: hasMapMoveSinceLastRefine,
        position: position,
        currentRefinement: currentRefinement,
        refine: refine
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var position = props.position,
          currentRefinement = props.currentRefinement;
      var previousPosition = state.previousPosition,
          previousCurrentRefinement = state.previousCurrentRefinement;
      var positionChanged = !isEqualPosition(previousPosition, position);
      var currentRefinementChanged = !isEqualCurrentRefinement(previousCurrentRefinement, currentRefinement);
      var sliceNextState = {
        previousPosition: position,
        previousCurrentRefinement: currentRefinement
      };

      if (positionChanged || currentRefinementChanged) {
        return _objectSpread(_objectSpread({}, sliceNextState), {}, {
          hasMapMoveSinceLastRefine: false
        });
      }

      return sliceNextState;
    }
  }]);

  return Connector;
}(Component);

_defineProperty(Connector, "propTypes", {
  hits: PropTypes.arrayOf(PropTypes.object).isRequired,
  isRefinedWithMap: PropTypes.bool.isRequired,
  enableRefineOnMapMove: PropTypes.bool.isRequired,
  refine: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  position: LatLngPropType,
  currentRefinement: BoundingBoxPropType
});

export default connectGeoSearch(Connector);